import * as DataUtils from './DataUtils.js';

export const PreFiltro = {
  TODOS: 'todos',
  CLUB_RIVAL: 'club_rival',
  SELECCION_RIVAL: 'seleccion_rival',
};

export const GetEquipos = async (prefiltro, objetoFiltro, pais, tipoEquipo, nombre, categoria) => {
  let url;
  let separador = '?';
  switch (prefiltro) {
    case PreFiltro.CLUB_RIVAL: {
      url = 'clubes/' + objetoFiltro.id + '/rivales/equipos';
      break;
    }
    case PreFiltro.SELECCION_RIVAL: {
      url = `selecciones_pais/${objetoFiltro.idPais}/rivales/equipos`;
      if (objetoFiltro?.categoria?.id) {
        url += `?categoria=${objetoFiltro.categoria.id}`;
        separador = '&';
      }
      break;
    }
    case PreFiltro.TODOS:
    default: {
      url = 'equipos';
      break;
    }
  }
  if (pais) {
    url += separador + 'pais=' + pais.id;
    separador = '&';
  }
  if (tipoEquipo && tipoEquipo.codigo) {
    url += separador + 'tipoEquipo=' + tipoEquipo.codigo;
    separador = '&';
  }
  if (categoria && categoria.codigo) {
    url += separador + 'categoria=' + categoria.codigo;
    separador = '&';
  }
  if (nombre) {
    url += separador + 'nombreParcial=' + nombre;
  }
  return DataUtils.FetchLista(url);
};
